import clsx from "clsx";
import { _ } from "i18n";
import { NavOptions } from "../types"
import { type GPPermissionsResponse, type GamePageResponse, type GamePageLazyResponse } from "../types";

interface MainNavBarProps {
    selectedTab: NavOptions;
    permissions?: GPPermissionsResponse;
    gameData: GamePageResponse;
    gameDataLazy?: GamePageLazyResponse;
    handleSelectTab: (tak: NavOptions) => void;
}

export function MainNavBar({ selectedTab, gameData, gameDataLazy, handleSelectTab }: MainNavBarProps) {
    return (
        <div className="mainNavBar-container">
            <div
                className={clsx("navBarTab", { selected: selectedTab === NavOptions.FullGame || selectedTab === NavOptions.Clips, })}
                onClick={() => handleSelectTab(NavOptions.FullGame)}
            >
                {_("gamePage.label.video")}
            </div>
            {
                gameData.game.isAnalysisFinished
                && (
                    gameData.permissions.showPlayerStats
                    || gameData.permissions.showTeamStats
                ) && <div
                    className={clsx("navBarTab", { selected: selectedTab === NavOptions.TeamStats || selectedTab === NavOptions.PlayerStats })}
                    aria-disabled={!gameDataLazy}
                    onClick={() => {
                        !!gameDataLazy ? handleSelectTab(!gameData.permissions.showTeamStats ? NavOptions.PlayerStats : NavOptions.TeamStats) : undefined;
                    }}
                >
                    {_("gamePage.label.data")}
                </div>}
            {gameData.permissions?.adminOptions &&
                <div
                    className={clsx("navBarTab", { selected: selectedTab === NavOptions.Admin, })}
                    onClick={() => {
                        handleSelectTab(NavOptions.Admin);
                    }}
                >
                    {_("label.admin")}
                </div>}
            {
                gameData.game.isAnalysisFinished && gameData.permissions.showDataInsights &&
                <div
                    className={clsx("navBarTab", { selected: selectedTab === NavOptions.DataInsights, })}
                    aria-disabled={!gameDataLazy}
                    onClick={() => {
                        !!gameDataLazy ? handleSelectTab(NavOptions.DataInsights) : undefined;
                    }}
                >
                    {_("gamePage.label.dataInsights")}
                </div>
            }
            {gameData.permissions.showPhysicalAnalysis &&
                <div
                    className={clsx("navBarTab", { selected: selectedTab === NavOptions.PhysicalAnalysis })}
                    aria-disabled={!gameDataLazy}
                    onClick={() => {
                        !!gameDataLazy ? handleSelectTab(NavOptions.PhysicalAnalysis) : undefined;
                    }}
                >
                    {_("gamePage.label.physicalMetrics")}
                </div>}
        </div>
    )
}
